import { cx } from '@freightapi/ui'
import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { useConsoleI18n } from '../lib/locale'

/**
 * Settings is a section with pages of its own, not a single screen: M3-02 fills members, later
 * tickets add the organisation and billing next to it. The sub-navigation lives here, so
 * `src/nav.ts` keeps one line for the whole section (M3-01, acceptance criterion).
 */
export const Route = createFileRoute('/_app/settings')({ component: Settings })

const TABS = [
  { to: '/settings/members', label: 'settings.nav.members' },
  { to: '/settings/organization', label: 'settings.nav.organization' },
  { to: '/settings/security', label: 'settings.nav.security' },
] as const

function Settings() {
  const { t } = useConsoleI18n()

  return (
    <section className="flex flex-col gap-6">
      <h1 className="font-semibold text-display text-ink">{t('settings.title')}</h1>
      <nav aria-label={t('settings.title')}>
        <ul className="flex list-none flex-wrap gap-1 p-0">
          {TABS.map((tab) => (
            <li key={tab.to}>
              <Link
                to={tab.to}
                className={cx(
                  'block min-h-touch rounded-card px-3 py-2 font-medium text-body text-muted',
                  'hover:bg-surface',
                )}
                activeProps={{ className: 'bg-brand-50 text-brand-700' }}
              >
                {t(tab.label)}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <Outlet />
    </section>
  )
}
